import React, { useRef, lazy } from 'react';
import { motion, useInView } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/bu3KnapXgVzx7FZf8Hdmj9/PORTADA_BONO_1.png',
    title: 'Oraciones y Afirmaciones Poderosas',
    subtitle: '50 Oraciones y Afirmaciones Adaptadas a la Energía Argentina',
    desc: "Elimina el miedo de 'no saber qué decir'. Incluye 5 oraciones por categoría (prosperidad, amor, protección, limpieza, descanso) y 10 afirmaciones para repetir MIENTRAS te sumergís los pies. Escritas en español neutro argentino.",
    example: '"Libero todo lo que no me pertenece. Mi energía es solo mía. Recupero mi poder y mi paz."'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/wX4bH1vcz6h2ow5PuLz9mC/PORTADA_BONO_2.png',
    title: 'Audio de Meditación Matutina y Diurna',
    subtitle: 'Meditación Profesional',
    desc: 'Voz femenina argentina (cálida, relajante, nada robótica). El audio hace TODO el trabajo mental por vos. Resultado: Mente relajada + Cuerpo relajado = Resultados 3x más profundos.',
    example: null
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/c5bfrUeE9KAsFP3wL95Zs2/PORTADA_BONO_3.png',
    title: 'Calendario Lunar Argentino 2026',
    subtitle: 'Los Mejores Días del Año para Cada Tipo de Ritual',
    desc: 'Sincronizá tus rituales con el cosmos. Calendario específico para Argentina (hemisferio sur). Días marcados por color según fase lunar, eclipses y solsticios. Ya no improvisás, tenés el timing exacto.',
    example: 'Ej: ¿Querés hacer un ritual de prosperidad? → "21 de marzo (Luna Nueva en Aries) - DÍA PERFECTO"'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/hV3erCmQfvJB89pP9yRv4N/PORTADA_BONO_4.png',
    title: 'Protocolo "Reset de 7 Días"',
    subtitle: 'El Plan Exacto que Vas a Seguir en Tu Primera Semana',
    desc: 'Eliminamos la fricción de no saber por dónde empezar. Un plan estructurado día por día: Día 1 (Limpieza), Día 2 (Descanso), Día 3 (Autoestima), etc. No tenés que pensar, solo seguir el plan.',
    example: 'Al día 8, ya tenés resultados medibles.'
  }];
  return <section ref={ref} className="py-20 sm:py-32 bg-[#2F4538] text-[#F5F0E8] relative overflow-hidden" data-id="element-11">
      <div className="absolute inset-0 opacity-10" aria-hidden="true" data-id="element-12">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#D4AF37] rounded-full blur-[150px]" data-id="element-13"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-15">
          <div className="inline-flex items-center gap-2 bg-[#D4AF37]/20 text-[#D4AF37] px-6 py-3 rounded-full mb-6 border border-[#D4AF37]/30" data-id="element-16">
            <Gift className="w-5 h-5" data-id="element-17" />
            <span className="font-bold text-sm tracking-wider uppercase" data-id="element-18">
              Regalos Exclusivos
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6" data-id="element-19">
            Y además HOY recibís GRATIS estos 4 bonos
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white/5 backdrop-blur-sm rounded-3xl p-6 sm:p-8 border border-white/10 flex flex-col h-full hover:bg-white/10 transition-colors" data-id="element-21">
              <div className="flex flex-col sm:flex-row gap-5 mb-6" data-id="element-22">
                {/* Cover image */}
                <div className="relative shrink-0 mx-auto sm:mx-0" data-id="element-23">
                  <div className="absolute -inset-2 bg-[#D4AF37]/20 rounded-2xl blur-xl" aria-hidden="true" data-id="element-24"></div>
                  <div className="relative w-32 h-32 sm:w-28 sm:h-28 rounded-2xl overflow-hidden shadow-xl border border-[#D4AF37]/30" data-id="element-25">
                    <img src={bonus.image} alt={`Portada del bono ${index + 1}: ${bonus.title}`} width={400} height={400} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-26" />
                  </div>
                </div>

                {/* Title block */}
                <div className="flex-1 min-w-0" data-id="element-27">
                  <div className="text-[#D4AF37] font-bold text-sm tracking-wider mb-1 text-center sm:text-left" data-id="element-28">
                    BONUS {index + 1}
                  </div>
                  <h3 className="text-xl font-bold text-[#F5F0E8] leading-tight text-center sm:text-left" data-id="element-29">
                    {bonus.title}
                  </h3>
                </div>
              </div>

              <h4 className="font-semibold text-[#B4A7D6] mb-4" data-id="element-30">
                {bonus.subtitle}
              </h4>
              <p className="text-[#F5F0E8]/80 leading-relaxed mb-6 flex-1" data-id="element-31">
                {bonus.desc}
              </p>

              {bonus.example && <div className="bg-black/20 p-4 rounded-xl border border-white/5 text-sm text-[#F5F0E8]/90 italic" data-id="element-32">
                  {bonus.example}
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}